import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { Redirect, useLocation } from 'react-router-dom';

import Nav from 'components/Nav';
import Grid from 'components/Grid';
import Logo from 'components/Logo';
import { IntegrationConfig } from 'models/integrationConfig';
import { AppStates } from 'store';

const Navbar: FC = () => {
  const location = useLocation();

  const providersConfig = useSelector((state: AppStates) => state.providersConfig) ?? {};
  const logsConfig = useSelector((state: AppStates) => state.logPage);

  const isConfig = providersConfig?.data?.some((provider: IntegrationConfig) => provider.type === logsConfig.filters?.provider || '');

  if (
    (
      !providersConfig
      || providersConfig?.data?.length === 0
      || !isConfig
    ) &&
    location.pathname === '/logs'
  ) {
    return <Redirect to="/" />;
  }

  return (
    <Nav
      direction="row"
      background="dark-color"
      pad={{ horizontal: 'medium' }}
      height="46px"
      align="center"
      justify="between"
      fill="horizontal"
      border={{
        color: 'dark-border-color',
        size: 'xsmall',
        style: 'solid',
        side: 'bottom',
      }}
    >
      <Grid columns={['1fr', '1fr', '1fr']} fill align="center">
        <Logo />
      </Grid>
    </Nav>
  );
};

export default Navbar;
